import styled from 'styled-components'
import { LoginCardProps } from './types'

export const Card = styled.div<LoginCardProps>`
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '548px')};
  padding: 20px 48px 20px;
  margin: 0 auto;
  background-color: #ffffff;
`
